import type {
  SchedulingSlotResponse
} from '../../client'
import {
  AvailabilityDot
} from './AvailabilityDot'
import type {
  SlotAvailability
} from './schedulingUtils'
import {
  formatTime
} from './schedulingUtils'

export function DayTimeList({
  dayLabel,
  slots,
  displayTimezone,
  timezoneSelector,
  onSelect,
  availability
}: {
  dayLabel: string,
  slots: SchedulingSlotResponse[],
  displayTimezone: string,
  timezoneSelector: React.ReactNode,
  onSelect: (slot: SchedulingSlotResponse) => void,
  // Visitor-availability overlay: free/busy per slot id once the visitor
  // connected their calendar; undefined/null leaves the list unmarked.
  availability?: Map<number, SlotAvailability> | null
}): JSX.Element {
  return (
    <div className="flex flex-col">
      <h3 className="text-sm font-medium text-gray-900">{dayLabel}</h3>
      <div className="mt-1 mb-3">{timezoneSelector}</div>
      {slots.length === 0 ? (
        <p className="text-sm text-gray-500">No times available this day.</p>
      ) : (
        <div className="flex flex-col gap-2 md:max-h-80 md:overflow-y-auto md:pr-1">
          {slots.map((slot) => {
            const slotAvailability = availability?.get(slot.id)
            // Busy slots stay clickable — calendars can be wrong — they're
            // just visually de-emphasized next to the red dot.
            return (
              <button
                key={slot.id}
                type="button"
                onClick={() => onSelect(slot)}
                className={`w-full px-4 py-3 text-sm font-medium border border-gray-300 rounded-lg hover:border-primary-500 hover:text-primary-500 transition-colors flex items-center justify-center gap-2 ${
                  slotAvailability === 'busy' ? 'text-gray-400 opacity-60' : 'text-gray-700'
                }`}
              >
                {slotAvailability && (
                  <AvailabilityDot
                    status={slotAvailability}
                    label={slotAvailability === 'busy' ? "You're busy at this time" : "You're free at this time"}
                  />
                )}
                {formatTime(slot.start_time, displayTimezone)}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}
